import React from 'react';
import { Button } from '@televet/kibble-ui/build/components/Button';

const MoreOptionsButton = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ onClick }, ref): JSX.Element => {
    return (
      <Button
        iconName="dotsVertical"
        variant="ghostNeutral"
        size="md"
        onClick={(e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>): void => {
          e.stopPropagation();
          if (typeof onClick === 'function') onClick(e);
        }}
        ref={ref}
      />
    );
  },
);

MoreOptionsButton.displayName = 'MoreOptionsButton';

export default MoreOptionsButton;
